import { WalletRouterUtils } from '../../../src/app/core/services/wallet-router/wallet-router-utils';
import { RouteTypes } from '../../../src/app/route-types';
import Constants from '../common/constants';
import Helpers from '../common/helpers';
import Store from '../store';
import window from '../window';
export default class Setup {
    /**
     * On load of the window fire this
     */
    static onload() {
        // create the instance identifer
        Store.setInstanceIdentifier(Helpers.get32ByteRandomValue());
        Store.setUserTrackingId(Helpers.getMeta(Constants.trackingMetaTagName));
        Store.setUrl(Helpers.getWalletURL());
        const appId = Helpers.getAppId();
        if (!appId) {
            throw new Error('You must supply an `appId` in the query string of the wallet sdk script else the wallet will not startup.');
        }
        Store.setAppId(appId);
        window.funwallet.deepLinkRouteTypes = {
            accountSettings: '/' + RouteTypes.accountSettings,
            securitySettings: '/' + RouteTypes.securitySettings,
            securitySettingsTwoFactorAuthentication: '/' + RouteTypes.securitySettingsTwoFactorAuthentication,
            securitySettingsApprovedDevices: '/' + RouteTypes.securitySettingsApprovedDevices,
            responsibleGaming: '/' + RouteTypes.responsibleGaming,
            responsibleGamingTakeABreak: '/' + RouteTypes.responsibleGamingTakeABreak,
            responsibleGamingSelfExclude: '/' + RouteTypes.responsibleGamingSelfExclude,
            funds: '/' + RouteTypes.funds,
            convertFunds: '/' + RouteTypes.convertFunds,
            withdrawFunds: '/' + RouteTypes.withdrawFunds,
            depositAddress: '/' + RouteTypes.depositAddress,
            depositCrypto: '/' + RouteTypes.depositCrypto,
            depositCard: '/' + RouteTypes.depositCard,
            historyTransfers: '/' + RouteTypes.historyTransfers,
            historyTransactions: '/' + RouteTypes.historyTransactions,
        };
        window.funwallet.getWalletFollowerURL = () => Helpers.buildUpWalletInstanceURL();
        window.funwallet.getWalletLeaderURL = () => Helpers.buildUpWalletInstanceURL({ isLeader: true });
        window.funwallet.getWalletPopUpURL = () => Helpers.buildUpWalletInstanceURL({ isPopUp: true });
        Helpers.addCssToHead(`${window.funwallet.url}assets/sdk/fun-wallet-sdk.css`);
        window.funwallet.formatRouterToValue = (value) => WalletRouterUtils.formatRouter(value);
        window.funwallet.unformatRouterToValue = (value) => WalletRouterUtils.unformatRouter(value);
        this.setupLeaderIframe();
    }
    /**
     * Sets up the leader iframe
     */
    static setupLeaderIframe() {
        // window.onload on apps like angular etc can take sometime to show the html
        // this makes sure we load it when its visible
        let retryCount = 0;
        const internal = setInterval(() => {
            try {
                retryCount++;
                const leaderIFrameElement = Helpers.getLeaderHTMLIFrameElement();
                leaderIFrameElement.src = window.funwallet.getWalletLeaderURL();
                leaderIFrameElement.setAttribute('frameBorder', '0');
                leaderIFrameElement.setAttribute('scrolling', 'no');
                clearInterval(internal);
            }
            catch (error) {
                // mute error if its within range else do not
                if (retryCount >= this.MAX_LEADER_SETUP_ATTEMPTS) {
                    clearInterval(internal);
                    throw new Error('Fun wallet sdk could not find the leader instance. Please make sure its visible in the dom.');
                }
            }
        }, this.TRY_EVERY_MILLISECONDS);
    }
}
// this means it will try for 20 seconds before stopping
Setup.MAX_LEADER_SETUP_ATTEMPTS = 2000;
Setup.TRY_EVERY_MILLISECONDS = 10;
//# sourceMappingURL=setup.js.map